import React, {Component} from 'react';
import InputText from '../components/input/InputText';
import InputPassword from '../components/input/InputPassword';
import {fetchGet, fetchPost} from '../cruds/remote';
import getLabel from '../translations/messages';
import logo from '../images/powered.png';
import './Login.css';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {username: '', password: ''};
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: '',
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const {username, password} = this.state;

    if (username && password) {
      fetchPost('auth/login', {username, password})
        .then(res => {
          if (!res.value) {
            this.setState({error: getLabel(this.props.locale, 'login.error')});

          } else {
            this.purgeStorage();
            localStorage.setItem('x-auth-token', res.value);
            this.checkPasswordChange();
          }
        })
        .catch(err => {
          this.setState({error: err.status + ' ' + err.statusText});
        });

    } else {
      this.setState({error: getLabel(this.props.locale, 'login.missingUsernameOrPassword')});

    }

  };

  checkPasswordChange = () => {
    const {onSuccessfulLogin, onPasswordChange} = this.props;

    fetchGet('auth/loggedUser')
      .then(user => {
        if (user.changePasswordNeeded) {
          onPasswordChange();
        } else {
          localStorage.setItem('loggedUser', JSON.stringify(user));
          onSuccessfulLogin();
        }
      });
  };

  purgeStorage = () => {
    const locale = localStorage.getItem('locale');
    localStorage.clear();
    localStorage.setItem('locale', locale);
  };

  render() {
    return (
      <div className="Login">
        <div className="login-container">
          <div className="login-content">
            <div className="login-header">
              <label className="headline1 darkGrayText"></label>
              <label className="headline1 orangeText">PHOENIX</label>
            </div>
            {this.props.passwordChanged ?
              <div className="info">{getLabel(this.props.locale, 'login.passwordChanged')}</div> : ''}
            {this.state.error ? <div className="error">{this.state.error}</div> : ''}
            <form onSubmit={this.handleSubmit}>
              <InputText
                name="username"
                label="login.username"
                handleChange={this.handleChange}
                autoFocus
              />
              <InputPassword
                name="password"
                label="login.password"
                handleChange={this.handleChange}
              />
              <div>
                <button type="submit" className="Button btn-orange">
                  {getLabel(this.props.locale, 'login.submit')}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="logo">
          <a href="https://www.jsb-solutions.com/it"><img src={logo} alt="jsb"/></a>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/main/pages/Login.js